const ACCOUNTS = "accounts";
const ACTIVITY = "loren-activity";
const ADMIN = "admin";
const ALL = "all";
const ANALYSIS = "analysis";
const ASSET = "asset";
const ASSETS = "assets";
const ASSETS_LIST = "assets-list";
const COMPANIES = "companies";
const CUSTOM_SHAFT_MONITORING_DASHBOARD = "shaft-monitoring";
const DASHBOARD = "dashboard";
const DEFINE = "define";
const DELETE = "delete";
const DETAILS = "details";
const DEVICES = "devices";
const EDIT = "edit";
const EVENT = "loren-event";
const FAQ = "faq";
const GEOFENCING = "geofencing";
const GROUPS = "groups";
const LOGIN = "login";
const MAP = "map";
const MAP_ASSETS_LIST = "map-assets-list";
const NOTIFICATIONS = "notifications";
const NOTIFICATION_PANEL = "notification-panel";
const PLANS = "plans";
const PROFILE = "profile";
const REPORTS = "reports";
const ROLES = "roles";
const ROLES_FORM = "role-form";
const SHAFT_LIST = "shaft-list";
const SHAFT_GROUPING_LIST = "shaft-grouping-list";
const TRACES = "traces";
const USER = "user";
const USER_ACCESS = "user-access";
const NOTIFICATIONS_SETTINGS = "notifications-settings";

export abstract class LorenRoutesBase {
  abstract route: string;

  all() {
    return `/${this.route}`;
  }

  define() {
    return `/${this.route}/${DEFINE}`;
  }

  details(id: number, forPrimaryOutlet = true) {
    return `${forPrimaryOutlet ? "/" : ""}${this.route}/${id}/${DETAILS}`;
  }

  edit(id: number) {
    return `/${this.route}/${id}/${EDIT}`;
  }

  editRoute() {
    return `/${this.route}/:id/${EDIT}`;
  }

  delete(id: number) {
    return `/${this.route}/${id}/${DELETE}`;
  }
}

class LorenGroupRoutes extends LorenRoutesBase {
  route = GROUPS;
}

class LorenReportsRoutes extends LorenRoutesBase {
  route = REPORTS;
}

class LorenDevicesRoutes extends LorenRoutesBase {
  route = DEVICES;
}

/**
 * @deprecated Use LinkGen
 */
class LorenAssetsRoutes extends LorenRoutesBase {
  route = ASSETS;

  /**
   * @deprecated
   */
  edit(id: number): string {
    return LinkGen.Assets.Edit(id);
  }

  /**
   * @deprecated
   */
  delete(id: number): string {
    return `${this.route}/${id}/${DELETE}`;
  }

  /**
   * @deprecated
   */
  define(): string {
    return LinkGen.Assets.New();
  }
}

class LorenActivityRoutes extends LorenRoutesBase {
  route = ACTIVITY;
}

class LorenAutomationPlansRoutes extends LorenRoutesBase {
  route = PLANS;

  edit(id: number): string {
    return `${this.route}/${id}/${EDIT}`;
  }

  define(): string {
    return `${this.route}/${DEFINE}`;
  }
}

class LorenAdminAccountsRoutes extends LorenRoutesBase {
  route = `${ADMIN}/${ACCOUNTS}`;
}

class LorenAdminCompaniesRoutes extends LorenRoutesBase {
  route = `${ADMIN}/${COMPANIES}`;
}

class LorenAdminDevicesRoutes extends LorenRoutesBase {
  route = `${ADMIN}/${DEVICES}`;

  edit(id: number) {
    return `${this.route}/${id}/${EDIT}`;
  }

  delete(id: number) {
    return `${this.route}/${id}/${DELETE}`;
  }
}

export const LOREN_ROUTES = {
  ACTIVITY,
  ADMIN,
  ACCOUNTS,
  ALL,
  ANALYSIS,
  ASSET,
  ASSETS,
  ASSETS_LIST,
  COMPANIES,
  CUSTOM_SHAFT_MONITORING_DASHBOARD,
  DASHBOARD,
  DEFINE,
  DELETE,
  DETAILS,
  DEVICES,
  EDIT,
  EVENT,
  FAQ,
  GEOFENCING,
  GROUPS,
  LOGIN,
  MAP,
  MAP_ASSETS_LIST,
  NOTIFICATIONS,
  NOTIFICATION_PANEL,
  PLANS,
  PROFILE,
  REPORTS,
  ROLES,
  ROLES_FORM,
  SHAFT_LIST,
  SHAFT_GROUPING_LIST,
  TRACES,
  USER,
  USER_ACCESS,
  NOTIFICATIONS_SETTINGS,
  ADMIN_ACCOUNTS: new LorenAdminAccountsRoutes(),
  ADMIN_COMPANIES: new LorenAdminCompaniesRoutes(),
  ADMIN_DEVICES: new LorenAdminDevicesRoutes(),
  ASSETS_: new LorenAssetsRoutes(),
  DEVICES_: new LorenDevicesRoutes(),
  GROUPS_: new LorenGroupRoutes(),
  PLANS_: new LorenAutomationPlansRoutes(),
  REPORTS_: new LorenReportsRoutes(),
  SHAFT_MONITORING_ACTIVITY: new LorenActivityRoutes(),
};


export const LinkGen = {
  Assets: Object.assign(() => '/assets-list', {
    New: () => `/asset/new`,
    Edit: (id: number) => `/asset/${id}/edit`,
    Detail: (id: number) => `/asset/${id}`,
  }),
  VisionPipelines: Object.assign(() => '/admin/vision-pipelines', {
    Detail: (id: number) => `/admin/vision-pipelines/${id}`,
    New: () => `/admin/vision-pipelines/new`,
    Edit: (id: number) => `/admin/vision-pipelines/${id}/edit`,
  }),
  AutomationPlans: Object.assign(() => `/${PLANS}`, {
    New: () => `/${PLANS}/${DEFINE}`,
    Edit: (id: number) => `/${PLANS}/${id}/${EDIT}`,
  }),
}